module.exports = __webpack_public_path__ + "static/media/library.72d3fe75.jpg";